import { ValidationFields } from '../validators'
import moment from 'moment/moment'
import { EUROPEAN_DATE, getTimezoneLessMoment } from '../momentjs'

export const InternshipFileTypes = Object.freeze({
  CONVENTION: 'CONVENTION',
  COVER_LETTER: 'COVER_LETTER',
  RESUME: 'RESUME',
  OTHER: 'OTHER'
})
export const InternshipFileTypeColors = Object.freeze({
  CONVENTION: 'orange',
  COVER_LETTER: 'blue',
  RESUME: 'green',
  OTHER: 'purple'
})

export const INTERNSHIP_REQUEST_FILE_VALIDATORS = [
  { key: ValidationFields.TYPE, validator: s => s.type !== null },
  { key: ValidationFields.ORIGINAL_NAME, validator: s => s.originalName !== null }
]

export const getOriginalName = file => file.originalName
export const getExtension = file => file.extension
export const getType = file => file.type
export const getTypeColor = file => InternshipFileTypeColors[getType(file)]
export const getCreatedAt = file => getTimezoneLessMoment(file.createdAt).format(EUROPEAN_DATE)

export class InternshipRequestFile {
  constructor ({ id = -1, type = InternshipFileTypes.OTHER, originalName = null, mimeType = null, extension = null, size = null, individualInternshipRequest = null, createdAt = moment() } = {}) {
    this.id = id
    this.type = type
    this.originalName = originalName
    this.mimeType = mimeType
    this.extension = extension
    this.size = size
    this.individualInternshipRequest = individualInternshipRequest
    this.createdAt = getTimezoneLessMoment(createdAt)
  }

  toRequestBody = () => {
    const body = { ...this }

    body.individualInternshipRequest = body.individualInternshipRequest === null ? null : body.individualInternshipRequest.id

    return body
  }
}
